module.exports = __webpack_public_path__ + "static/media/PRATIC - LIMPEZA GERAL.901b635b.pdf";